// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b893S","content":"styles_content__a-hwS","decline":"styles_decline__A61mG"};